import { render } from "./ChipListEditor.vue?vue&type=template&id=501dd205&scoped=true&ts=true"
import script from "./ChipListEditor.vue?vue&type=script&lang=ts"
export * from "./ChipListEditor.vue?vue&type=script&lang=ts"

import "./ChipListEditor.vue?vue&type=style&index=0&id=501dd205&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-501dd205"]])

export default __exports__